import { da } from "date-fns/locale";

export const SET_DELETE_CS_MODAL = 'SET_DELETE_CS_MODAL';
export const SET_EDIT_CS_MODAL = 'SET_EDIT_CS_MODAL';
export const SET_DELETE_CS_DATA = 'SET_DELETE_USER_DATA';
export const SET_EDIT_CS_DATA = 'SET_EDIT_CS_DATA';
export const SET_CHANGE_STATUS = 'SET_CHANGE_STATUS';
export const CUSTOMERS_SIGNUP = 'CUSTOMERS_SIGNUP';
export const FETCH_CUSTOMER_ALL = 'FETCH_CUSTOMER_ALL';
export const ADD_NEW_CUSTOMER = 'ADD_NEW_CUSTOMER';
export const OPEN_MESSAGE_MODAL = 'OPEN_MESSAGE_MODAL';
export const SAVE_BACKUP_CUSTOMERS = 'SAVE_BACKUP_CUSTOMERS';


const setDeleteCSModal = data => ({
    type: SET_DELETE_CS_MODAL,
    payload: { data },
});

const setEditModal = data => ({
    type: SET_EDIT_CS_MODAL,
    payload: { data },
});


const setCSdeleteData = data => ({
    type: SET_DELETE_CS_DATA,
    payload: { data },
});

const setEditCSData = data => ({
    type: SET_EDIT_CS_DATA,
    payload: { data },
});

const setChangeStatus = data => ({
    type: SET_CHANGE_STATUS,
    payload: { data },
});


const setCustomers = data =>
({
    type: CUSTOMERS_SIGNUP,
    payload: { data },
});

const setFetchCustomer = data =>
({
    type: FETCH_CUSTOMER_ALL,
    payload: { data },
});

const setAddNewCustomer = data =>
({
    type: ADD_NEW_CUSTOMER,
    payload: { data },
});

const setOpenMessageModal = data =>
({
    type: OPEN_MESSAGE_MODAL,
    payload: { data },
});

//GET FROM DISPATCH
export const deleteCSModal = data => dispatch => {
    dispatch(setDeleteCSModal(data));
};

export const editCSModal = data => dispatch => {
    dispatch(setEditModal(data));
};

export const deleteCSdata = data => dispatch => {
    dispatch(setCSdeleteData(data));
};

export const editCSdata = data => dispatch => {
    dispatch(setEditCSData(data));
};

export const changeStatus = data => dispatch => {
    dispatch(setChangeStatus(data));
};

export const fetchAllCustomers = data => dispatch => {
    dispatch(setFetchCustomer(data));
};

export const allCustomers = data => async dispatch => {
    try {
        dispatch(setCustomers(data));
    } catch (error) {
        console.log(error);
    }
};

export const addNewCustomer = data => async dispatch => {
    try {
        dispatch(setAddNewCustomer(data));
    } catch (error) {
        console.log(error);
    }
};

export const openMessageModal = data => async dispatch => {
    try {
        dispatch(setOpenMessageModal(data));
    } catch (error) {
        console.log(error);
    }
};

export const saveBackupCustomers = data => dispatch => {
    dispatch({
        type: SAVE_BACKUP_CUSTOMERS,
        payload: { data }
    });
};
